import { executePut, executeGetNoResultError } from '../common/apiCaller'
import { GetReservationAcceptabilityDto, PutReservationAcceptInputDto } from '../dto/reservationAcceptabilityDto'

const apiName = 'citizen'
const apiPath = '/reservations/reservation-acceptability'

export const resultErrorCodePutReservationAccept = {
  /** 事業の利用上限超過 */
  usageLimitExceeded: 3,
  /** 承諾期限切れ */ 
  consentExpired: 9,
} as const

export const executeGetReservationAcceptability = (id: string) => {
  return executeGetNoResultError<GetReservationAcceptabilityDto>(apiName, `${apiPath}/${id}`)
}

export const executePutReservationAccept = (id: string, input: PutReservationAcceptInputDto) => {
  return executePut<null>(apiName, `${apiPath}/${id}`, input)
}

